import React, { createContext, useContext, useEffect } from "react";
import { ShowCardsType, getCreatorCards } from "../../services/CardServices";
import { useAuth } from "../AuthProvider";
import {
  UsePaginatedDataResult,
  usePaginatedData,
} from "../helper/usePaginatedData";

interface CreatorCardsContextProps {
  cardsState: UsePaginatedDataResult<ShowCardsType>;
  // archivedCardsState: UsePaginatedDataResult<ShowCardsType>;
}

const CreatorCardsContext = createContext<CreatorCardsContextProps | undefined>(
  undefined
);

export const CreatorCardsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const cardsState = usePaginatedData<ShowCardsType>();
  // const archivedCardsState = usePaginatedData<ShowCardsType>();
  const { user } = useAuth();
  const limit = 16;

  useEffect(() => {
    if (user && cardsState.page > 0)
      cardsState.fetchData(limit, getCreatorCards);

    // only rerun on page change ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsState.page]);

  // useEffect(() => {
  //   if (user && cardsState.page > 0)
  //     cardsState.fetchData(limit, getCreatorArchivedCards);

  //   // only rerun on page change ...
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [archivedCardsState.page]);

  useEffect(() => {
    cardsState.setPage(0);
    cardsState.setHasMore(true);
    cardsState.setFilteredData([]);
    cardsState.setData([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <CreatorCardsContext.Provider
      value={{
        cardsState,
        // archivedCardsState,
      }}
    >
      {children}
    </CreatorCardsContext.Provider>
  );
};

export const useCreatorCardsContext = () => {
  const context = useContext(CreatorCardsContext);
  if (!context) {
    throw new Error(
      "useCreatorCardsContext must be used within a CreatorCardsProvider"
    );
  }
  return context;
};
